<template>
  <div style="max-width:60%;">
    <ReportTableDashboard></ReportTableDashboard>
  </div>
</template>

<script>
// import messages from "../../modules/lang/export";
import ReportTableDashboard from "@/pages/admin/components/report/table/reportTableDashboard.vue";
export default {
  // i18n: { messages },
  components:{
    ReportTableDashboard
  },
  data(){
    return {

    }
  }
}
</script>